/**
 * Typography Token System
 * Standardized font sizes, weights, and related properties for the entire ERP system.
 * Reference these tokens instead of hardcoding sizes in components.
 *
 * Usage:
 *   sx={{ fontSize: TYPE.md, fontWeight: TYPE.semibold }}
 *   sx={{ fontSize: TYPE.xs }} // for chip labels, overlines
 */

export const TYPE = {
  // Semantic size scale
  xs: '0.75rem',     // 12px — chip labels, small badges, overline text
  sm: '0.8125rem',   // 13px — column headers, table caption, section labels
  base: '0.875rem',  // 14px — caption, small text
  md: '0.9375rem',   // 15px — body2, table cells, form inputs, buttons
  lg: '1rem',        // 16px — body1, regular paragraph
  xl: '1.125rem',    // 18px — body default, h5 equivalent
  kpi: '1.3rem',     // 20.8px — KPI card values (standardized)
  '2xl': '1.25rem',  // 20px — h4, subheading
  '3xl': '1.375rem', // 22px — h3, section heading
  '4xl': '1.625rem', // 26px — h2, page section heading
  '5xl': '1.875rem', // 30px — h1, page title

  // Font weights
  normal: 400,       // regular text
  medium: 500,       // form labels, medium emphasis
  semibold: 600,     // card titles, strong text
  bold: 700,         // headings, strong emphasis

  // Font families
  mono: '"SF Mono", "Fira Code", "Fira Mono", Menlo, Consolas, monospace',
} as const;

// Export type for TypeScript strict mode
export type Typography = typeof TYPE;
